import React, { useState } from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../../../hooks/useDialogState";
import { useTreeState } from "../../../../../hooks/useTreeState";
import { useComponentState } from "../../../../../hooks/useComponentState";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Alert from "@mui/material/Alert";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TreeComponentTypeService from "../../../../../services/TreeComponentTypeService";
import {trackPromise} from "react-promise-tracker";

import {useStylesDialog} from "../../../../../shared/useStyleDialog";

// Fenster zum Bearbeiten des ausgewählten Bauteils

// Transition legt fest, wie das Fenster erscheint
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function UpdateCompDialog() {

  const classesDialog = useStylesDialog();
  const dialog = useDialogState();
  const tree = useTreeState();
  const component = useComponentState();
  const token = useSelector((state) => state.keycloakToken);
  const realm = useSelector((state) => state.theRealm);
  const UpdateCompDialogOpen = dialog.updateCompOpen;
  const setUpdateCompDialogOpen = dialog.setUpdateCompOpen;
  const TreeSelected = tree.selected;
  const setTreeSelected = tree.setSelected;
  const BTName = component.name;
  const setBTName = component.setName;
  const BTCode = component.code;
  const setBTCode = component.setCode;
  const BTDesc = component.desc;
  const setBTDesc = component.setDesc;
  const [alertOpen, setAlertOpen] = useState(false);

  const Component_Update = async () => {
    try {
      const data = {
        name: BTName.trim(),
        description: BTDesc.trim(),
        cafmId: TreeSelected.cafm_id.trim(),
        globalId: TreeSelected.global_id.trim(),
        parentComponent: TreeSelected.parent_objecttype_id,
        parentCafmId: TreeSelected.parent_cafm_id,
        parentGlobalId: TreeSelected.parent_global_id,
        code: BTCode.trim(),
      };

      await trackPromise((async () => {
        await TreeComponentTypeService.saveComponentType(token, realm, data);
        const result = await TreeComponentTypeService.getTreeData(token, realm);
        tree.setItems(result.data);
        const selItem = {...TreeSelected, name: data.name, description: data.description};
        setTreeSelected(selItem);
      })());
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div>
      <Dialog
        className={classesDialog.dialog}
        open={UpdateCompDialogOpen}
        onClose={() => {
          setUpdateCompDialogOpen(false);
          setBTName("");
          setBTCode("");
          setBTDesc("");
        }}
        TransitionComponent={Transition}
        fullScreen
      >
        <AppBar className={classesDialog.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                setUpdateCompDialogOpen(false);
                setBTName("");
                setBTCode("");
                setBTDesc("");
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classesDialog.title}>
              Bauteil <b> {TreeSelected.name} </b> bearbeiten
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={() => {
                setAlertOpen(true);

                BTName === ""
                  ? setBTName(TreeSelected.name)
                  : setBTName(BTName);

                BTCode === ""
                  ? setBTCode(TreeSelected.code)
                  : setBTCode(BTCode);

                BTDesc === ""
                  ? setBTDesc(TreeSelected.description)
                  : setBTDesc(BTDesc);
              }}
            >
              Bestätigen
            </Button>
          </Toolbar>
        </AppBar>
        <List>
          <ListItem>
            <TextField
              autoFocus
              required
              defaultValue={TreeSelected.name}
              margin="dense"
              id="Comp_name"
              label="Name"
              type="text"
              fullWidth
              onChange={(e) => setBTName(e.target.value)}
            />
          </ListItem>
          <ListItem>
            <TextField
              autoFocus
              required
              disabled
              defaultValue={TreeSelected.code}
              margin="dense"
              id="Comp_code"
              label="Code"
              type="text"
              fullWidth
              onChange={(e) => setBTCode(e.target.value)}
            />
          </ListItem>
          <ListItem>
            <TextField
              autoFocus
              defaultValue={TreeSelected.description}
              margin="dense"
              id="Comp_description"
              label="Beschreibung"
              type="text"
              fullWidth
              onChange={(e) => setBTDesc(e.target.value)}
            />
          </ListItem>
          <Divider />
        </List>
      </Dialog>
      <Dialog
        open={alertOpen}
        className={classesDialog.dialogAlert}
        onClose={() => setAlertOpen(false)}
      >
        <AppBar className={classesDialog.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setAlertOpen(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classesDialog.title}>
              Bauteil <b>{BTName}</b> bearbeiten
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <DialogContentText>Eingaben korrekt?</DialogContentText>
          <Alert variant="outlined" severity="info">
            <DialogContentText>Name: {BTName}</DialogContentText>
            <DialogContentText>Beschreibung: {BTDesc}</DialogContentText>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)} color="primary">
            Abbrechen
          </Button>
          <Button
            onClick={async () => {
              setAlertOpen(false);
              await Component_Update();
              setUpdateCompDialogOpen(false);
            }}
            color="primary"
            autoFocus
          >
            Bestätigen
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
